// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty[data-v-398401e2]{flex:1;display:flex;align-items:center;justify-content:center;flex-direction:column;margin-top:6em;min-height:100%}i[data-v-398401e2]{font-size:10em;opacity:1%}h2[data-v-398401e2],i[data-v-398401e2]{margin:0}h3[data-v-398401e2]{margin-top:2em}", ""]);
// Exports
module.exports = exports;
